import { useMutation, useQuery } from "@tanstack/react-query";
import { auditlogService } from "../../services/auditlog.service";
import { AuditlogPayload } from "../../domain/auditlog.interface";
import { MODULE_NAME } from "@/domain/auditlog.enum";

const { create, findByModule } = auditlogService;

export const useCreateAuditlog = () => {
	return useMutation({
		mutationFn: (data: AuditlogPayload) => create(data),
	});
};

export const useGetAuditlog = (
	module: MODULE_NAME,
	from: string,
	to: string,
	pageNumber: number,
	pageSize: number,
	lastDocId?: string,
) => {
	return useQuery({
		queryKey: ["nalcam-audit-get"],
		queryFn: () =>
			findByModule({ module, from, to, pageNumber, pageSize, lastDocId }),
	});
};
